<template>
  <span class="exam-type-badges">
    <span v-if="hasRetinoscopyPart(examination)" class="exam-type-badge ret" :title="t('retinoscopy')">RET</span>
  </span>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n'
import Examination, {hasRetinoscopyPart} from '@/models/customer/Examination'

defineProps<{ examination: Examination }>()

const {t} = useI18n({
  messages: {
    en: {retinoscopy: 'Retinoscopy'},
    ar: {retinoscopy: 'Retinoscopy'}
  }
})
</script>

<style scoped>
.exam-type-badges {
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 0.25rem;
  margin-inline-start: 0.4rem;
}

.exam-type-badge {
  padding: 0 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.3rem;
}

.exam-type-badge.eye {
  background: #DCF3E2;
  color: #1E6B3A;
}

.exam-type-badge.ret {
  background: #DBECFC;
  color: #1E4F7B;
}
</style>
